/**
 * MiniRouletteLogo — small spinning wheel used as a brand mark in
 * the Roulette page header and the Explore & Earn tile.
 */
const COLORS = ['#E11D48', '#F59E0B', '#004D61', '#3B82F6', '#006B85'];
const SEG = 8; // 8 visible slices for clarity at small size
const ANG = 360 / SEG;

function buildPath(i) {
  const r = 19;
  const sRad = (i * ANG - 90) * (Math.PI / 180);
  const eRad = ((i + 1) * ANG - 90) * (Math.PI / 180);
  const x1 = r * Math.cos(sRad);
  const y1 = r * Math.sin(sRad);
  const x2 = r * Math.cos(eRad);
  const y2 = r * Math.sin(eRad);
  return `M 0 0 L ${x1.toFixed(2)} ${y1.toFixed(2)} A ${r} ${r} 0 0 1 ${x2.toFixed(2)} ${y2.toFixed(2)} Z`;
}

export default function MiniRouletteLogo({ size = 32, spin = true, className = '' }) {
  return (
    <span
      className={`inline-flex items-center justify-center relative ${className}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <span
        className={spin ? 'roulette-logo-spin' : ''}
        style={{
          width: size,
          height: size,
          display: 'inline-block',
          transformOrigin: '50% 50%',
        }}
      >
        <svg viewBox="-22 -22 44 44" width={size} height={size} style={{ display: 'block' }}>
          {/* Gold rim */}
          <circle r="20" fill="#1F1207" stroke="#FFD93D" strokeWidth="2.5" />
          {/* Segments */}
          {Array.from({ length: SEG }).map((_, i) => (
            <path
              key={i}
              d={buildPath(i)}
              fill={COLORS[i % COLORS.length]}
              stroke="#FFFFFF"
              strokeWidth="0.6"
            />
          ))}
          {/* Stud dots on the rim */}
          {Array.from({ length: SEG }).map((_, k) => {
            const a = (k * ANG) * (Math.PI / 180);
            return (
              <circle
                key={`d-${k}`}
                cx={20 * Math.cos(a - Math.PI / 2)}
                cy={20 * Math.sin(a - Math.PI / 2)}
                r="1.1"
                fill="#FFF8C7"
              />
            );
          })}
          {/* Center hub */}
          <circle r="5" fill="#0B0F0C" stroke="#FFD93D" strokeWidth="1.2" />
        </svg>
      </span>
      {/* Tiny static pointer on top (does NOT spin) */}
      <svg
        viewBox="0 0 12 14"
        width={Math.max(8, size * 0.32)}
        height={Math.max(10, size * 0.4)}
        style={{ position: 'absolute', top: -2, left: '50%', transform: 'translateX(-50%)' }}
      >
        <path d="M6 13 L1 2 A 5 5 0 0 1 11 2 Z" fill="#FFD93D" stroke="#FFFFFF" strokeWidth="1" />
      </svg>
    </span>
  );
}
